import { put, call, all, spawn, takeEvery } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import { signupServices } from '../services/signup';
import * as types from '../constants/signup';
import * as actions from '../actions/signup';

// Sign up
function* apiSignupRequestWorker(action) {
  try {
    const result = yield call(signupServices.apiSignupRequest, action);

    yield put(actions.apiSignupRequestSuccess(result, action));
  } catch (err) {
    yield put(actions.apiSignupRequestFailed(err, action));
  }
}

function* apiSignupRequestWatcher() {
  yield takeEvery(types.API_SIGNUP_REQUEST, apiSignupRequestWorker);
}

function* apiChangePasswordRequestWorker(action) {
  try {
    const result = yield call(signupServices.apiChangePasswordRequest, action);

    yield put(actions.apiChangePasswordSuccess(result, action));
  } catch (err) {
    yield put(actions.apiChangePasswordFailed(err, action));
  }
}

function* apiChangePasswordRequestWatcher() {
  yield takeEvery(
    types.API_CHANGE_PASSWORD_REQUEST,
    apiChangePasswordRequestWorker,
  );
}
function* apiUserConfirmationRequestWorker(action) {
  try {
    const result = yield call(
      signupServices.apiUserConfirmationRequest,
      action,
    );

    yield call(toast.success, result.data?.detail);
    yield put(actions.apiUserConfirmationSuccess(result, action));
  } catch (err) {
    yield put(actions.apiUserConfirmationFailed(err.response?.data));
  }
}

function* apiResendConfirmationRequestWorker(action) {
  try {
    const result = yield call(
      signupServices.apiResendConfirmationRequest,
      action,
    );
    yield put(actions.apiResendConfirmationSuccess(result.data));
  } catch (err) {
    yield put(actions.apiResendConfirmationFailed(err.response?.data));
  }
}

function* apiResendConfirmationRequestWatcher() {
  yield takeEvery(
    types.API_RESEND_CONFIRMATION_REQUEST,
    apiResendConfirmationRequestWorker,
  );
}

function* apiSetPasswordRequestWorker(action) {
  try {
    const result = yield call(signupServices.apiSetPasswordRequest, action);
    yield call(toast.success, result.data?.detail);
    yield put(actions.apiSetPasswordSuccess(result.data));
  } catch (err) {
    const data = err.response?.data;
    yield call(toast.error, data?.detail || 'Could not send the link.');
    yield put(actions.apiSetPasswordFailed(data));
  }
}

function* apiSetPasswordRequestWatcher() {
  yield takeEvery(types.API_SET_PASSWORD_REQUEST, apiSetPasswordRequestWorker);
}

function* apiUserConfirmationRequestWatcher() {
  yield takeEvery(
    types.API_USER_CONFIRMATION_REQUEST,
    apiUserConfirmationRequestWorker,
  );
}

// Read more information about root sagas in the documentation
// https://redux-saga.js.org/docs/advanced/RootSaga.html
export default function* signupRootSaga() {
  const sagas = [
    apiSignupRequestWatcher,
    apiChangePasswordRequestWatcher,
    apiUserConfirmationRequestWatcher,
    apiResendConfirmationRequestWatcher,
    apiSetPasswordRequestWatcher,
  ];

  yield all(
    sagas.map(saga =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.log(e);
          }
        }
      }),
    ),
  );
}
